import './App.css';
/* src/App.svelte generated by Svelte v3.34.0 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "../web_modules/svelte/internal.js";

import { organizations, industries, emojis } from "./data.js";

function create_fragment(ctx) {
	let header;
	let t1;
	let div1;
	let div0;
	let h2;
	let t2_value = /*candidate*/ ctx[0].name + "";
	let t2;
	let t3;
	let p;
	let t5;
	let h3;
	let t6_value = capitalize(/*industry*/ ctx[1]) + "";
	let t6;
	let t7;
	let t8;
	let t9;
	let footer;
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			header = element("header");
			header.innerHTML = `<h1 class="svelte-1tgkpz0">Unicorn Generator 🦄</h1>`;
			t1 = space();
			div1 = element("div");
			div0 = element("div");
			h2 = element("h2");
			t2 = text(t2_value);
			t3 = space();
			p = element("p");
			p.textContent = "for";
			t5 = space();
			h3 = element("h3");
			t6 = text(t6_value);
			t7 = space();
			t8 = text(/*emoji*/ ctx[2]);
			t9 = space();
			footer = element("footer");
			button = element("button");

			button.innerHTML = `<span>Generate another</span> 
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="svelte-1tgkpz0"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path></svg>`;

			attr(header, "class", "svelte-1tgkpz0");
			attr(h2, "data-testid", "company");
			attr(h2, "class", "svelte-1tgkpz0");
			attr(p, "class", "svelte-1tgkpz0");
			attr(h3, "data-testid", "industry");
			attr(h3, "class", "svelte-1tgkpz0");
			attr(div0, "class", "candidate svelte-1tgkpz0");
			attr(div1, "class", "container svelte-1tgkpz0");
			attr(button, "type", "button");
			attr(button, "class", "svelte-1tgkpz0");
			attr(footer, "class", "svelte-1tgkpz0");
		},
		m(target, anchor) {
			insert(target, header, anchor);
			insert(target, t1, anchor);
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, h2);
			append(h2, t2);
			append(div0, t3);
			append(div0, p);
			append(div0, t5);
			append(div0, h3);
			append(h3, t6);
			append(h3, t7);
			append(h3, t8);
			insert(target, t9, anchor);
			insert(target, footer, anchor);
			append(footer, button);

			if (!mounted) {
				dispose = listen(button, "click", /*generate*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*candidate*/ 1 && t2_value !== (t2_value = /*candidate*/ ctx[0].name + "")) set_data(t2, t2_value);
			if (dirty & /*industry*/ 2 && t6_value !== (t6_value = capitalize(/*industry*/ ctx[1]) + "")) set_data(t6, t6_value);
			if (dirty & /*emoji*/ 4) set_data(t8, /*emoji*/ ctx[2]);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(header);
			if (detaching) detach(t1);
			if (detaching) detach(div1);
			if (detaching) detach(t9);
			if (detaching) detach(footer);
			mounted = false;
			dispose();
		}
	};
}

function randomNumber(max) {
	return Math.floor(Math.random() * max);
}

function capitalize(text) {
	return `${text.substr(0, 1).toUpperCase()}${text.substr(1)}`;
}

function instance($$self, $$props, $$invalidate) {
	let candidate, industry, emoji;

	function generate() {
		let good = false;

		while (!good) {
			$$invalidate(0, candidate = organizations[randomNumber(organizations.length)]);
			let list = Object.keys(industries);
			$$invalidate(1, industry = list[randomNumber(list.length)]);
			$$invalidate(2, emoji = emojis[randomNumber(emojis.length)]);
			good = candidate.industries.indexOf(industry) < 0;
		}
	}

	generate();
	return [candidate, industry, emoji, generate];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;